import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getRelatedGuides } from "@/lib/relatedGuides";

// Contextual "Read our guides" horizontal strip for destination & tour pages.
export const RelatedGuides = ({ tokens, excludeSlug, count = 8, title = "Guides you'll find useful" }) => {
  const [guides, setGuides] = useState([]);
  const tokensKey = JSON.stringify(tokens || []);
  useEffect(() => {
    let active = true;
    getRelatedGuides(tokens, count, excludeSlug).then((g) => { if (active) setGuides(g); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokensKey, count, excludeSlug]);
  if (guides.length < 3) return null;
  return (
    <section className="py-16 md:py-20 border-t border-[var(--tx-border)]" data-testid="related-guides">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-8 flex items-end justify-between gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.24em] text-[var(--tx-gold)]">Read our guides</div>
            <h2 className="mt-2 font-display text-3xl md:text-4xl font-light">{title}</h2>
          </div>
          <Link
            to="/journal"
            data-testid="related-guides-all"
            className="hidden md:inline-flex items-center gap-2 text-sm text-[var(--tx-gold)] hover:gap-3 transition-all duration-300"
          >
            All guides <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="flex gap-6 overflow-x-auto pb-4 snap-x [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="related-guides-track">
          {guides.map((g) => (
            <Link
              key={g.slug}
              to={`/journal/${g.slug}`}
              data-testid={`related-guide-${g.slug}`}
              className="group snap-start shrink-0 w-72 border border-[var(--tx-border)] bg-[var(--tx-bg-2)] overflow-hidden hover:border-[var(--tx-gold)]/40 transition-colors duration-500"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={g.image}
                  alt={g.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="text-xs uppercase tracking-[0.18em] text-[var(--tx-gold)]">{g.category}</div>
                <h3 className="mt-2 font-display text-lg font-light leading-snug line-clamp-2 group-hover:text-[var(--tx-gold)] transition-colors duration-300">
                  {g.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
